const replaceHTMLEntityWithSymbol = (string) => {
  if (!string) return;
  const htmlEntityRegex = new RegExp(/&#([0-9]+);/, 'g'); // 'g' option to match all occurrences if there are multiple
  return string.replace(htmlEntityRegex, (match, charCode) => String.fromCharCode(parseInt(charCode)));
};

window.rhws = replaceHTMLEntityWithSymbol;

export default replaceHTMLEntityWithSymbol;
